import ActivationPackageDefaultEvent from './ActivationPackageDefaultEvent';

const ActivationPackageSubmitted = ({ event }: { event: any }) => {
  return <ActivationPackageDefaultEvent event={event} action="Activation Package Submitted" />;
};

export default ActivationPackageSubmitted;
